import React, { FC } from 'react';
import { usePublicJobDetailDataQuery } from '../../hooks';
import { Typography } from '../../../../../components/Typography';
import { PaddingBox } from '../../../../../components/PaddingBox';
import { isBadOrEmptyString } from '../../../../../predicates/string';
import { PublicJobDetailBox } from '../PublicJobDetailBox';
import { PublicJobDetailApplyButton } from './PublicJobDetailApplyButton';

export const PublicJobDetailApply: FC = () => {
	const {
		data: { salaryFormatted },
	} = usePublicJobDetailDataQuery();

	return (
		<PublicJobDetailBox>
			{!isBadOrEmptyString(salaryFormatted) && (
				<PaddingBox bottomSmall>
					<Typography
						fontSize='20px'
						bold
					>
						{salaryFormatted}
					</Typography>
				</PaddingBox>
			)}
			<PublicJobDetailApplyButton />
		</PublicJobDetailBox>
	);
};
